import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  EVENT_EMITTER,
  ONE_FILTER_ITEM_VOID
} from "../../constants/GenericSearchConstants";
import {
  FilterOneItem,
  FilterOneItemElement,
  ItemByCreate,
  QueryFilter
} from "../../model/FilterOneItem";
import { LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import { ConfigSearcher } from "@/shared/models/ConfigSearcher";
import { STRING_TYPE } from "@/shared/constants/GeneralConstants";

@Component({
  name: "SearchOneFilter"
})
export default class SearchOneFilter extends Vue {
  @Prop() itemFilter!: FilterOneItem;
  @Prop({ default: () => 0 }) clearAll!: number;
  @Prop({ default: () => false }) attach!: string | boolean;
  @Prop({ default: () => false }) disabled!: boolean;
  @Prop({ default: () => "" }) updateSearch!: string;

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  listItems: any[] = [];
  filterSelectIndex = 0;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  searchText = "";
  showNotData = false;
  typeList = false;
  refSelect = "";
  loadingNewData = false;
  dataPending = false;
  searchDefault?: ConfigSearcher;

  beforeMount() {
    const searcher = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE.SEARCHER) ?? "[]"
    ) as ConfigSearcher[];
    this.searchDefault = searcher.find(
      search => search.keyRef == this.$vnode.key
    );
  }

  get listFilter() {
    return this.itemFilter?.filters ?? [];
  }

  mounted() {
    this.refSelect = JSON.stringify(ONE_FILTER_ITEM_VOID);

    const defaulIndex = this.listFilter?.findIndex(
      filter =>
        (this.searchDefault &&
          this.searchDefault.defaultFilterId == filter.id) ||
        (!this.searchDefault && filter.default)
    );
    this.filterSelectIndex = defaulIndex >= 0 ? defaulIndex : 0;
  }

  get referenceValueItem() {
    return this.filterSelect.id;
  }

  get attachLocal(): string | boolean {
    return this.attach == undefined
      ? true
      : typeof this.attach == STRING_TYPE && this.attach
      ? "#" + this.attach
      : !!this.attach;
  }

  get labelHint() {
    return this.itemFilter?.labelHint ? this.itemFilter.labelHint : "";
  }

  get showLoader() {
    return (
      !this.typeList &&
      !this.itemFilter?.filterOut &&
      !this.itemFilter?.oneCharge &&
      this.dataPending &&
      this.listItems.length > 1
    );
  }

  get itemText() {
    return this.typeList ? "name" : this.referenceValueItem;
  }

  get filterSelect(): FilterOneItemElement {
    return this.listFilter.length
      ? this.listFilter[this.filterSelectIndex]
      : { name: "", id: "" };
  }

  get labelComboBox() {
    return this.filterSelect.name + (this.itemFilter?.labelTitle ?? "");
  }

  get canAddElement(): boolean {
    return (
      this.showNotData &&
      Boolean(this.searchText) &&
      Boolean(this.filterSelect.canAdd) &&
      !(this.listItems && this.listItems.length)
    );
  }

  get showNotFoundData(): boolean {
    return (
      (this.filterSelect.showNoData ?? true) &&
      this.showNotData &&
      Boolean(this.searchText) &&
      !this.filterSelect.canAdd &&
      !(this.listItems && this.listItems.length)
    );
  }

  getItems() {
    this.$nextTick(() => {
      this.getItemsAsync();
    });
  }

  async getDataByFunction(filter: QueryFilter) {
    return this.searchText && this.itemFilter?.getData
      ? await this.itemFilter.getData(filter)
      : [];
  }

  async getItemsAsync() {
    const filter = this.getFilter();
    if (this.typeList) {
      return;
    }
    if (this.itemFilter?.filterOut) {
      this.$emit(EVENT_EMITTER.FILTER_OUT, filter);
      return;
    }
    let listItems = await this.getDataByFunction(filter);

    this.showNotData = true;
    const lengthList = listItems.length;
    if (lengthList == 1) {
      this.selectItem(listItems[0]);
      if (!this.itemFilter?.persistentList) {
        this.changeEstateList(false);
      }
    } else {
      this.selectVoid();
    }
    if (this.filterSelect.oneResult && lengthList != 1) {
      listItems = [];
    }
    this.dataPending = true;
    this.listItems = listItems;
  }

  createNewElement() {
    this.$emit(EVENT_EMITTER.CREATE_NEW_ELEMENT, {
      searchText: this.searchText,
      filter: this.filterSelect.id
    } as ItemByCreate);
  }

  selectVoid() {
    this.selectItem(ONE_FILTER_ITEM_VOID);
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  selectItem(item: any) {
    if (this.typeList) {
      item.type = this.referenceValueItem;
    }
    const refSelect = JSON.stringify(item);
    if (refSelect === this.refSelect) {
      return;
    }
    this.refSelect = refSelect;
    this.$emit(EVENT_EMITTER.SELECT_ITEM, item);
  }

  getFilter(): QueryFilter {
    const filterQuery = { [this.referenceValueItem]: this.searchText };
    return filterQuery;
  }
  focusInput() {
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    (this.$refs.typeBox as any).focus();
  }

  @Watch("filterSelectIndex")
  changrFilterSelect() {
    if (
      this.itemFilter.listItemFilterObj &&
      this.itemFilter.listItemFilterObj[this.referenceValueItem]
    ) {
      this.listItems = this.itemFilter.listItemFilterObj[
        this.referenceValueItem
      ];
      this.typeList = true;
      this.searchText = "";
      this.changeEstateList(true);
    } else {
      this.typeList = false;
      this.listItems = [];
    }
    this.changeSearchText();
  }

  changeEstateList(newState: boolean) {
    this.$nextTick(() => {
      if (this.$refs.typeBox) {
        /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
        (this.$refs.typeBox as any).isMenuActive = newState;
      }
    });
  }

  @Watch("clearAll")
  clearData() {
    if (!this.typeList) {
      this.listItems = [];
    }
    this.refSelect = JSON.stringify(ONE_FILTER_ITEM_VOID);
    this.changeSearchText();
    this.searchText = "";
  }

  clearSelect() {
    this.selectVoid();
    this.clearData();
  }

  @Watch("searchText")
  changeSearchText() {
    this.showNotData = false;
  }

  onEnterPressed() {
    this.$emit(EVENT_EMITTER.SEARCH_TEXT, this.searchText);
  }

  @Watch("updateSearch")
  updateExternSearchText() {
    if (this.itemFilter?.defaultUpdate) {
      this.filterSelectIndex = this.itemFilter.filters?.findIndex(
        filter => filter.id == this.itemFilter.defaultUpdate
      );
    }
    this.searchText = this.updateSearch;
    this.getItemsAsync();
  }

  async getNewData() {
    if (
      this.loadingNewData ||
      !this.dataPending ||
      this.listItems.length == 0
    ) {
      return;
    }
    this.loadingNewData = true;
    const lastReference = this.listItems[this.listItems.length - 1].id;
    const filter: QueryFilter = {
      ...this.getFilter(),
      lastReference
    };
    const listItems = await this.getDataByFunction(filter);
    if (listItems.length == 0) {
      this.dataPending = false;
    } else {
      this.listItems.push(...listItems);
    }
    this.loadingNewData = false;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  onFinalScroll(entries: any[]) {
    const isShow = entries.findIndex(event => event.isIntersecting) != -1;
    if (!isShow) {
      return;
    }
    this.getNewData();
  }
}
